export const appendTrackingQueryParams = (url: string, queryParams: string) => {
  if (!url) return "";
  const hashIndex = url.indexOf("#");
  const baseUrl = hashIndex === -1 ? url : url.slice(0, hashIndex);
  const hash = hashIndex === -1 ? "" : url.slice(hashIndex);
  const params = queryParams.startsWith("&")
    ? queryParams.slice(1)
    : queryParams;
  const separator = baseUrl.includes("?") ? "&" : "?";
  return `${baseUrl}${separator}${params}${hash}`;
};
